export default Buffer.from("A+BSQ29weXJpZ2h0IDE5OTAtMjAwOSBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZC4KQWxsIHJpZ2h0cyByZXNlcnZlZC4KU2VlIC4vTElDRU5TReEHR0JLMkstSGEMoaIAhD8AAIQ+BgCEVgABvBgAAIRXBA2ERj4AvBqDIgCEQgYBhEQCAIQ9AQC8GwsBhEBBBKO/hEMfKBsJAQBBBKO9vBwdAAEAIABBFaShga5XAQIBEAEVAQ4ZAB8EAQIBAwYFgTIIAQIBDAERAQoZAB8EAQIBAwYFhnEO", "base64")


//////////////////
// WEBPACK FOOTER
// ./~/vue-pdf-signature/src/buffer-loader.js!./~/pdfjs-dist-sign/cmaps/GBK2K-V.bcmap
// module id = 667
// module chunks = 3